const config = {
  API_URL: process.env.REACT_APP_API_BASE_URL,
  CLIENT_ID: process.env.REACT_APP_CLIENT_ID,
  PROJECT_ID: process.env.REACT_APP_PROJECT_ID || "",
  GOOGLE_MAPS_API_KEY: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  ENV: process.env.REACT_APP_ENV,
};

export default config;
